<template>
  <div class="row">
    <div class="col-xs-12">
      <div class="table-responsive">
        <table cellpadding="1" cellspacing="1" class="table">
          <thead>
          <tr>
            <th class="col-lg-1">Last name</th>
            <th class="col-lg-1">First name</th>
            <th class="col-lg-4">Document</th>
            <th class="col-lg-5">
              <table cellpadding="1" cellspacing="1" class="table table-condensed table-striped" style="margin-bottom: 0">
                <thead>
                <th width="45%">Affiliation</th>
                <th width="45%">
                  <div v-if="editExpert" class="checkbox checkbox-info" style="margin: 0">
                    <input type="checkbox" style="position: absolute; opacity: 0;" id="all-experts-email" @click="selectAll" >
                    <label for="all-experts-email" class=""></label>Email
                  </div>
                </th>
                <th width="10%">Email Score</th>
                </thead>
              </table>
            </th>
            <th v-if="editExpert" class="col-lg-1"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="experts" v-for="(expert, key) in experts" :key="key">
            <td>{{expert.lastName}}</td>
            <td>{{expert.firstName}}</td>
            <td><a v-if="expert.doc" @click="showDocument(expert.doc)">{{expert.doc.title}}</a></td>
            <td>
              <table cellpadding="1" cellspacing="1" class="table table-condensed" style="margin-bottom: 0">
                <tbody>
                <tr v-if="expert.author_organisations.length !== 0 && affiliation.email"
                    v-for="(affiliation, key) in expert.author_organisations" :key="key + '-' + affiliation.selected">
                  <td width="45%" :style="{borderTop: key === 0 ? '0' : '1px solid #ddd'}">{{ (typeof affiliation.organisation === 'undefined' ? '' : affiliation.organisation.organisationName) }}</td>
                  <td width="45%" :style="{borderTop: key === 0 ? '0' : '1px solid #ddd'}">
                    <div v-if="editExpert" class="checkbox checkbox-info" style="margin: 0">
                      <input type="checkbox" style="position: absolute; opacity: 0;" :id="expert.authorID + '-' + key" :name="expert.authorID + '-' + key" v-model="affiliation.selected">
                      <label :for="expert.authorID + '-' + key" class=""> {{affiliation.email}}</label>
                    </div>
                    <div v-else>{{affiliation.email}}</div>
                  </td>
                  <td width="45%" :style="{borderTop: key === 0 ? '0' : '1px solid #ddd'}">
                    <template v-if="affiliation.emailScore">
                      <template v-if="affiliation.emailScore < 50">
                        <span style="color:red">{{affiliation.emailScore}}%</span>
                      </template>
                      <template v-else-if="affiliation.emailScore < 70">
                        <span style="color:orange">{{affiliation.emailScore}}%</span>
                      </template>
                      <template v-else>
                        <span style="color:green">{{affiliation.emailScore}}%</span>
                      </template>
                    </template>
                    <template v-else></template>
                  </td>
                </tr>
                </tbody>

              </table>
            </td>
            <td v-if="editExpert" style="vertical-align: middle">
              <div class="pull-right text-right">
                <div class="btn-group">
                  <button class="btn btn-default btn-xs" @click="editExpert(expert)"> <i class="fa fa-edit"></i> Edit</button>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal fade " id="modalShowDocument" tabindex="-1" role="dialog"  aria-hidden="true">
      <div v-if="documentToShow" class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">{{documentToShow.title}}</h4>
          </div>
          <div class="modal-body">
            <div v-html="documentToShow.abstract"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" >Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  props: ['experts', 'editExpert'],
  name: 'ExpertsListSelection',
  mounted () {
    $('#modalShowDocument').on('hidden.bs.modal', (e) => {
      this.documentToShow = null
    })
  },
  data () {
    return {
      documentToShow: null
    }
  },
  methods: {
    showDocument: function (doc) {
      this.documentToShow = doc
    },
    selectAll: function (e) {
      this.experts.forEach((expert) => {
        if (expert.author_organisations.length !== 0) {
          expert.author_organisations = expert.author_organisations.map((affiliation) => {
            affiliation.selected = e.target.checked
            return affiliation
          })
        }
      })
    }
  },
  watch: {
    documentToShow: function (doc) {
      if (doc !== null) {
        $('#modalShowDocument').modal('show')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/companyAuthor/ExpertsSelection.vue